import styles from "./styles/halloween-features-list.module.scss";
import Image from "next/image";
import sandClockIcon from "@/assets/discounts/halloween/sandclock.svg";
import headphonesIcon from "@/assets/discounts/halloween/headphones.svg";
import radioIcon from "@/assets/discounts/halloween/radio.svg";
import speedIcon from "@/assets/discounts/halloween/speed.svg";

const HalloweenFeaturesList = () => {
  return (
    <div className={styles.features_wrapper}>
      <div className={styles.features_column}>
        <div className={styles.feature}>
          <Image src={sandClockIcon} alt={""} />
          <div>Unlimited Generations</div>
        </div>
        <div className={styles.feature}>
          <Image src={headphonesIcon} alt={""} />
          <div>Custom Voices</div>
        </div>
      </div>
      <div className={styles.features_column}>
        <div className={styles.feature}>
          <Image src={radioIcon} alt={""} />
          <div>Premium Sound</div>
        </div>
        <div className={styles.feature}>
          <Image src={speedIcon} alt={""} />
          <div>Faster Speeds</div>
        </div>
      </div>
    </div>
  );
};

export default HalloweenFeaturesList;
